'use client'
import * as React from 'react'
import { createContext, ReactNode, useContext } from 'react'
import createLocale, { TPlaceholder } from './createLocale'

export type TLocaleContext = {
  [k: string]: string
} | null
const LocaleContext = createContext<TLocaleContext>(null)

export const useLocale = () => {
  const content: TLocaleContext = useContext(LocaleContext)
  if (!content) {
    throw new Error('useContent must be used within a LocaleProvider')
  }
  return React.useMemo(() => createLocale(content), [])
}

type TProps = {
  locale: {
    [k: string]: string
  }
  children: ReactNode
}
export const LocaleProvider = (props: TProps) => {
  return <LocaleContext.Provider value={props.locale}>{props.children}</LocaleContext.Provider>
}

type TI18nProps = {
  k: string
} & TPlaceholder

export const Locale = ({ k, ...placeholder }: TI18nProps) => {
  const t = useLocale()
  return t(k, placeholder)
}
